import React, { useCallback, useEffect, useMemo, useState } from "react"
// import { View } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from '~/ui/styled'
import useNavigation from "~hooks/useNavigation"
import { ChatList as ChatListComponent } from "~components/chat-list"
import { SearchBar } from "~components/SearchBar"
import { useStores, Chat } from "~models"
import useGroupActions from "~hooks/useGroupActions"
import { globalToast } from "~utils"

const Container = styled.View`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.blockBackground};
`
const SearchContent = styled.View`
  flex-shrink: 0;
  padding: 0 12px;
`
const ListArea = styled.View`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const ChatList: React.FC = () => {
  const navigation = useNavigation()
  const theme = useTheme()
  const { handleChatMessageReadAll } = useGroupActions()
  // const { handleCheckBindingPhone } = useCheckBinding()
  const { chatStore, contactStore } = useStores()
  const [searchText, setSearchText] = useState("")
  // 实时搜索会话, search会消息收到事件排序
  const data = chatStore?.search(searchText) || []
  useEffect(() => {
    chatStore.chats.forEach((chat) => chat.pruneForeignMessages())
  }, [chatStore])

  const listExtraData = data
    .map((c) => `${c.chat_id}:${c.lastMessage?.message_id ?? ""}:${c.messageUnreadCount}`)
    .join(",")
  const onItemClick = useCallback((chat) => {
    navigation.navigate("Chat", { chat_id: chat.chat_id })
  }, [navigation])

  const actionAllRead = useCallback(
    async (chat: Chat) => {
      chat.markAllRead({ report: false })
      try {
        await handleChatMessageReadAll({ chat_id: chat.id })
      } catch (err: any) {
        globalToast.show(err?.message || "全部已读失败")
      }
    },
    [handleChatMessageReadAll],
  )

  const actionDelete = useCallback((chat) => {
    chatStore.remove(chat)
  }, [])

  const actionPinOff = useCallback((chat) => {
    chat.clearPinTime()
  }, [])

  const actionPinToTop = useCallback((chat) => {
    chat.setPinTime()
  }, [])

  const actionMute = useCallback((chat) => {
    chat.publicToggleMuteChat(true)
  }, [])

  const actionUnmute = useCallback((chat) => {
    chat.publicToggleMuteChat(false)
  }, [])

  const swipeActionButtonConfigs = useMemo(
    () => [
      {
        visible: () => true,
        icon: "read",
        color: theme.colors.primary,
        text: "全部已读",
        onClick: actionAllRead,
      },
      {
        visible: () => true,
        icon: "trashCan",
        color: theme.colors.danger,
        text: "删除会话",
        onClick: actionDelete,
      },
      {
        visible: (chat: Chat) => {
          return !!chat.pinTime
        },
        icon: "pinOff",
        color: theme.colors.success,
        text: "取消置顶",
        onClick: actionPinOff,
      },
      {
        visible: (chat: Chat) => !chat.pinTime,
        icon: "pin",
        color: theme.colors.success,
        text: "置顶",
        onClick: actionPinToTop,
      },
      {
        visible: (chat: Chat) => {
          if (chat.chatTypeEnum === "GROUP") {
            return !chat.is_mute
          }
          const contact = chat?.receiver?.id? contactStore.byUserId(chat?.receiver.id) : null
          if (contact) {
            return !contact?.is_mute
          } else {
            return false
          }
        },
        icon: "bellOff",
        color: theme.colors.warning,
        text: "静音",
        onClick: actionMute,
      },
      {
        visible: (chat: Chat) => {
          if (chat.chatTypeEnum === "GROUP") {
            return chat.is_mute
          }
          const contact = chat?.receiver?.id ? contactStore.byUserId(chat?.receiver.id) : null
          if (contact) {
            return contact?.is_mute
          } else {
            return false
          }
        },
        icon: "bell",
        color: theme.colors.warning,
        text: "取消静音",
        onClick: actionUnmute,
      },
    ],
    [data],
  )

  return (
    <Container>
      <SearchContent>
        <SearchBar
          value={searchText}
          onChange={setSearchText}
          onClear={() => setSearchText("")}
        />
      </SearchContent>
      <ListArea>
        <ChatListComponent
          data={data}
          extraData={listExtraData}
          swipeActionButtonConfigs={swipeActionButtonConfigs}
          onItemClick={onItemClick}
        />
      </ListArea>
    </Container>
    
  )
}

export default observer(ChatList)